import { Box, Typography, IconButton } from '@mui/material'
import React from 'react'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import { LeagueItem, PartnerPageData } from 'types/types'
import { useRouter } from 'next/router'
import { useJoinMiniLeague } from 'hooks/useJoinMiniLeague'
import { useFormModalContext } from 'context/FormModalContext'
import { FORM_GATES } from '@/lib/constants'
import { getLeagueColor } from '@/utils/getLeagueColor'

type JoinLeagueItemProps = {
  isPublic?: boolean
  league: LeagueItem
  pageData: PartnerPageData
}

function JoinLeagueItem({ isPublic, pageData, league }: JoinLeagueItemProps) {
  const { openModal } = useFormModalContext()

  const router = useRouter()
  const { mutate, isLoading } = useJoinMiniLeague()

  const handleClick = () => {
    if (isLoading) {
      return
    }

    mutate(league.id as any, {
      onSuccess: () => {
        router.push({
          pathname: `/${pageData.company_domain}/mini-league/${league.id}`,
          query: { iframe: router.query.iframe },
        })
        openModal(FORM_GATES.JOIN_MINI_LEAGUE_PIN)
      },
    })
  }

  return (
    <Box
      onClick={handleClick}
      border="1px solid #DDD"
      borderRadius="12px"
      paddingY="12px"
      paddingX="16px"
      mb="12px"
      minHeight="56px"
      position="relative"
      display="flex"
      sx={{
        cursor: isLoading ? 'not-allowed' : 'pointer',
        width: '100%',
        backgroundColor: 'white',
        boxShadow: '1px 3px 10px rgba(52, 53, 73, 0.05)',
      }}
      justifyContent="center"
      flexDirection="column"
    >
      <Box
        display="flex"
        flexDirection="row"
        gap={2}
        alignItems="center"
        justifyContent="space-between"
      >
        <Box
          minWidth="64px"
          minHeight="64px"
          borderRadius="50%"
          position="absolute"
          display="flex"
          alignItems="center"
          boxShadow="1px 3px 10px 0px #00000026"
          justifyContent="center"
          overflow="hidden"
          sx={{
            background: league.logo ? 'transparent' : getLeagueColor(league.id),
            left: '-10px',
            top: '50%',
            transform: 'translateY(-50%)',
          }}
        >
          {league.logo && (
            <img
              src={league.logo}
              alt={league.name}
              style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }}
            />
          )}
        </Box>
        <Typography
          fontSize="14px"
          noWrap
          sx={{ maxWidth: '100%', textOverflow: 'ellipsis', ml: '50px' }}
        >
          {league.name}
        </Typography>
        <IconButton sx={{ padding: 0 }}>
          <KeyboardArrowRightIcon />
        </IconButton>
      </Box>
    </Box>
  )
}

export default JoinLeagueItem
